<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('maquinarias')">Maquinaria</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>Agregar
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.codigo" :error="form.errors.codigo" class="pr-6 pb-8 w-full lg:w-1/4" label="Código" required/>
          <select-input v-model="form.empresa_propietaria" :error="form.errors.empresa_propietaria" class="pr-6 pb-8 w-full lg:w-1/4" label="Empresa Propietaria" required>
             <option>Guadalupe</option>
            <option>Jose Luis Zavala</option>
            <option>Petrusmin</option>
            <option>San Pio</option>
            <option>YeshuaCons</option>
            <option>Cofiza Scc</option>
            <option>Geomax</option>
            <option>Urbymaq</option>
            <option>Tecfin Scc</option>
          </select-input>  
          <text-input v-model="form.clase" :error="form.errors.clase" class="pr-6 pb-8 w-full lg:w-1/4" label="Clase" required/>
          
          <text-input v-model="form.placas" :error="form.errors.placas" class="pr-6 pb-8 w-full lg:w-1/4" label="Placas" required/>
         <select-input v-model="form.grupo" :error="form.errors.grupo" class="pr-6 pb-8 w-full lg:w-1/4" label="Grupo" required>
             <option>Maquinaria</option>
            <option>Busetas</option>
            <option>General</option>
          </select-input>  
          <text-input v-model="form.marca" :error="form.errors.marca" class="pr-6 pb-8 w-full lg:w-1/4" label="Marca" required/>
          <text-input v-model="form.modelo" :error="form.errors.modelo" class="pr-6 pb-8 w-full lg:w-1/4" label="Modelo" required/>
          <select-input v-model="form.tipo" :error="form.errors.tipo" class="pr-6 pb-8 w-full lg:w-1/4" label="Tipo de Combustible" required>
             <option>Diesel Premium</option>
            <option>Extra</option>
            <option>Super</option>

          </select-input>  
          <text-input v-model="form.motor" :error="form.errors.motor" class="pr-6 pb-8 w-full lg:w-1/4" label="Motor" required/>
            <text-input v-model="form.chasis" :error="form.errors.chasis" class="pr-6 pb-8 w-full lg:w-1/4" label="Chasis" required/>
          <text-input v-model="form.potencia" :error="form.errors.pontencia" class="pr-6 pb-8 w-full lg:w-1/4" label="Potencia" required/>
          <text-input v-model="form.color" :error="form.errors.color" class="pr-6 pb-8 w-full lg:w-1/4" label="Color" required/>
          <text-input v-model="form.ano_fabricacion" :error="form.errors.ano_fabricacion" class="pr-6 pb-8 w-full lg:w-1/4" label="Año de Fabricación" required/>
          <text-input v-model="form.odometro_anterior" :error="form.errors.odometro_anterior" class="pr-6 pb-8 w-full lg:w-1/4" label="Odometro Anterior" required/>
        <text-input v-model="form.odometro_actual" :error="form.errors.odometro_actual" class="pr-6 pb-8 w-full lg:w-1/4" label="Odometro Actual" required/>
          <text-input v-model="form.observaciones" :error="form.errors.observaciones" class="pr-6 pb-8 w-full lg:w-2/4" label="Observaciones" required/>
          <text-input v-model="form.consumo_litro" :error="form.errors.consumo_litro" class="pr-6 pb-8 w-full lg:w-2/4" label="Consumo en Litro/Hora" required/>
</div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Agregar Maquinaria</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Add Maquinaria' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    organizations: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        codigo: null,
        empresa_propietaria: null,
        clase: null,
        placas: null,
        grupo: null,
        marca: null,
        modelo: null,
        motor: null,
        chasis: null,
        tipo: null,
        potencia: null,
        color: null,
        ano_fabricacion: null,
        odometro_anterior: null,
        odometro_actual: null,
        consumo_litro: null,
        observaciones: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('maquinarias.store'))
    },
  },
}
</script>
